import * as React from 'react';
import type { ButtonProps } from '~/common/components/ui/button';
import { Button } from '~/common/components/ui/button';
import { LucideLoader2 } from 'lucide-react';

interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
}

const LoadingButton = React.forwardRef<HTMLButtonElement, LoadingButtonProps>(
  ({ loading = false, children, disabled, ...props }, ref) => {
    return (
      <Button ref={ref} disabled={loading || disabled} {...props}>
        <span className={'contents'}>{loading && <LucideLoader2 className="mr-2 h-4 w-4 animate-spin" />}</span>
        {children}
      </Button>
    );
  }
);

LoadingButton.displayName = 'LoadingButton';

export { LoadingButton };
